<template>
    <div class="small-player" :data-playing="playing" @click.stop>
        <PlayButton
            :paused="playing"
            class="small-player__play-button"
            :class="{ 'is-active': playing }"
            @click.prevent="play"
        />
        <audio ref="audio" class="small-player__audio" :src="src" controls preload="none" />
    </div>
</template>

<script>
import PlayButton from './PlayButton';

export default {
    name: 'SmallPlayer',
    components: {
        PlayButton
    },
    props: {
        src: {
            type: String,
            required: true
        },
        active: {
            type: Boolean,
            default: true
        },
        sync: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            playing: false
        };
    },
    watch: {
        active() {
            if (!this.active) {
                if (this.$refs.audio && !this.$refs.audio.paused) {
                    this.$refs.audio.pause();
                    this.playing = false;
                    this.$refs.audio.currentTime = 0;
                }
            }
        }
    },
    mounted() {
        this.$refs.audio.onended = () => {
            this.playing = false;
        };
    },
    methods: {
        play() {
            if (!this.src) return;

            if (this.$refs.audio.paused) {
                if (this.sync) {
                    const players = document.querySelectorAll('.small-player[data-playing=true]');
                    if (players.length) {
                        players.forEach(p => {
                            // sorry
                            p.__vue__.play();
                        });
                    }
                }

                this.$refs.audio
                    .play()
                    .then(() => {
                        this.playing = true;
                        this.$emit('playing', { src: this.src });
                    })
                    .catch(() => {
                        return;
                    });
            } else {
                this.$refs.audio.pause();
                this.playing = false;
                this.$refs.audio.currentTime = 0;
                this.$emit('paused', { src: null });
            }
        }
    }
};
</script>

<style lang="scss" src="./SmallPlayer.scss"></style>
